export default {
  friends: {
    title: '친구',
    subtitle: '친구 관계 관리',
    addFriend: '친구 추가',
    noFriends: '아직 친구가 없습니다',
    addFriendsHint: '친구를 추가하여 함께 경비를 공유하세요!',
    unknownUser: '알 수 없는 사용자',
    removeFriend: '친구 삭제',
    confirmRemove: '친구를 삭제하시겠습니까?',
    removeSuccess: '친구 삭제 성공',
    removedFriend: '{name} 친구를 삭제했습니다',
    
    // 태그
    tagsUpdated: '친구 태그가 성공적으로 업데이트되었습니다',
    allFriends: '전체',
    noTaggedFriends: '"{tag}" 태그가 있는 친구가 없습니다',
    tryOtherTags: '다른 태그를 선택하거나 새 친구를 추가해보세요',
    
    // 로딩 상태
    loading: {
      title: '친구 연결 중...',
      subtitle: '친구 정보를 로드 중입니다',
    },
    // 태그 에디터
    editTags: '친구 태그 편집',
    selectedTags: '선택한 태그',
    presetTags: '프리셋 태그',
    myTags: '내 태그',
    addCustomTag: '커스텀 태그 추가',
    tagInputPlaceholder: '태그 이름을 입력하세요 (예: 헬스 친구)',
    tagHelp: '태그 도움말',
    tagAlreadyExists: '이 태그는 이미 존재합니다',
    tagSaveSuccess: '친구 태그가 성공적으로 업데이트되었습니다',
    tagSaveError: '저장 실패',
    saving: '저장 중...',
    save: '저장',
    noTagsSelected: '선택된 태그가 없습니다',
    success: '성공',
    error: '오류',
    tagHelpText: `• 태그는 친구를 분류하고 관리하는 데 도움이 됩니다
• 그룹 식사를 만들 때 태그로 초대자를 빠르게 선택할 수 있습니다
• 한 친구에게 여러 태그를 설정할 수 있습니다
• 짧고 명확한 태그 이름을 사용하는 것이 좋습니다`,
    
    // 프리셋 태그 번역
    presetTagCoworker: '동료',
    presetTagClassmate: '동급생', 
    presetTagNeighbor: '이웃',
    presetTagRoommate: '룸메이트',
    presetTagFamily: '가족',
    presetTagGymBuddy: '헬스 친구',
    presetTagGameBuddy: '게임 친구',
    presetTagLunchBuddy: '점심 친구',
    presetTagTravelBuddy: '여행 친구',
    presetTagStudyBuddy: '공부 친구',
    presetTagWorkPartner: '업무 파트너',
    
    // 검색 및 추가
    contactLabel: '연락처 정보',
    contactPlaceholder: '이메일, 사용자 이름 또는 전화번호 입력',
    searchPlaceholder: '사용자 이름, 이메일 또는 전화번호 검색',
    searchEmpty: '사용자를 찾을 수 없습니다',
    searchError: '검색에 실패했습니다. 나중에 다시 시도하세요',
    searchHint: '더 정확한 검색 결과를 위해 완전한 정보를 입력하세요',
    searching: '검색 중...',
    searchResults: '검색 결과',
    addByContact: '연락처 정보로 추가',
    scanQRCode: 'QR 코드 스캔으로 추가',
    shareMyQR: '내 QR 코드 공유',
    sendRequest: '친구 요청 보내기',
    
    // 친구 요청 메시지
    messageLabel: '친구 요청 메시지 (선택 사항)',
    messagePlaceholder: '자기소개를 작성하면 친구 요청이 수락되기 쉬워집니다',
    
    // 상태 메시지
    loadFailed: '친구 목록 로드에 실패했습니다',
    searchFailed: '검색 실패',
    incompleteUserInfo: '사용자 정보가 불완전합니다',
    enterContactInfo: '이메일, 사용자 이름 또는 전화번호를 입력하세요',
    requestSent: '친구 요청이 성공적으로 전송되었습니다!',
    requestFailed: '친구 요청 전송에 실패했습니다',
    removeFailed: '친구 삭제에 실패했습니다',
  }
};